@import 'styles/mixins';
@import 'styles/variables';

.root {
  display: flex;
  flex-direction: column;
  border-radius: 10px;
  background: var(--light-100);
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.04);
}

.listOption {
  display: flex;
  align-items: center;
  padding: 12px;
  gap: 12px;
  border-radius: 10px;
  border-bottom: 1px solid var(--dark-4, rgba(0, 0, 0, 0.04));

  .icon {
    display: flex;
    align-items: center;
  }

  .isSelectedIcon {
    margin-left: auto;
  }
}
